<template>
    <b-card class="block__objectiveList">
      <header>
        <p class="title">
          <PuSkeleton :loading="isLoading" :count="1" width='120px'>
            {{datalists.name}}
          </PuSkeleton>
          </p>
        <p class="number">
          <PuSkeleton :loading="isLoading" :count="1" width='20px'>
            {{datalists.value}}
          </PuSkeleton>
        </p>
      </header>

      <b-list-group v-if="datalists.underBonus && datalists.underBonus.length > 0">
        <b-list-group-item>
          <div class="entete">
            <div class="title">
              <PuSkeleton :loading="isLoading" :count="1" width='160px'>
                Point total Bonus
              </PuSkeleton>
            </div>
            <div class="number">
              <PuSkeleton :loading="isLoading" :count="1" width='20px'>
                {{ places ? (places > 0 ? '+' + places : places) : totalBonus() }}
              </PuSkeleton>
            </div>
          </div>
        </b-list-group-item>
      </b-list-group>

      <div class="sep"></div>

      <b-list-group>

        <b-list-group-item v-for="(list,index) of datalists.underBonus" :key="index">
          <div class="entete">
            <div class="title">
              <PuSkeleton :loading="isLoading" :count="1" width='160px'>
                {{list.name}}
              </PuSkeleton>
            </div>
            <div class="number">
              <PuSkeleton :loading="isLoading" :count="1" width='20px'>
                {{list.gain }} {{ list.gainType }}
              </PuSkeleton>
            </div>
          </div>
          <div class="label">
            <PuSkeleton :loading="isLoading" :count="1" width='120px'>
              <div class="left">
                <div class="title">
                  {{list.condition}}
                </div>
                <span class="result-grey">{{ Math.round(list.result) }}</span>
                <span class="result-grey"> {{ list.resultType }}</span>
              </div>
            </PuSkeleton>
          </div>

          <PuSkeleton :loading="isLoading" :count="1" width='200px'>
            <div class="wrapper">
                <b-progress :max="list.conditionValue" :value="Math.round(list.result)" :class="isPostive(list.result, list.conditionValue, list.conditionSigne)" v-if="list.conditionValue != null && list.conditionValue != '' && list.conditionSigne != '' && list.conditionSigne != null"></b-progress>
                <p class="value" :class="list.color" v-if="list.conditionValue != null && list.conditionValue != '' && list.conditionSigne != '' && list.conditionSigne != null">{{Math.round(list.result).toLocaleString()}}%</p>
            </div>
          </PuSkeleton>
        </b-list-group-item>
      </b-list-group>


    </b-card>
</template>


<script>

export default {
name:"wrapperObjectiveBonusList",
  props:{
    lists:{
      type:[Object],
      default: () => {
        return {}
        }
      },
    places:{
      default: 0
    },
    isLoad:{
      default: true
    },
  },
  data(){
    return {
      isLoading:true,
      datalists: {
        name:'Bonus',
          underBonus:[{},{}],
          value:'50'
        },
      under: '',
    }
  },
  created(){
    this.isLoading = this.isLoad;
    this.datalists = this.lists;
  },
  methods:{
    isPostive(value, compareValue, signe){
      if(signe == '>='){
        return value >= compareValue ?  'green' : '';
      } else if (signe == '<='){
        return value <= compareValue ?  'green' : '';
      }
    },
    totalBonus(){
      let total = 0;
      for (const underBonus of this.datalists.underBonus) {
        total += underBonus.gain;
      }

      return total;
    }
  },
  watch : {
    'isLoad' : function (){
      this.datalists = this.lists;
      this.isLoading = this.isLoad;
    },
  },
}
</script>
